import HintBox from './hint-box';
import './hint-box.scss';

export default HintBox;
